module.exports = __webpack_public_path__ + "045e7837fddb0c320c770bef844c0cb2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/15_D3.mp3
// module id = 95
// module chunks = 0